export default function PlusIcon({ color = "currentColor", size = "10" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.66667 5.66665H5.66667V9.66665H4.33334V5.66665H0.333336V4.33331H4.33334V0.333313H5.66667V4.33331H9.66667V5.66665Z"
        fill={color}
      />
    </svg>
  );
}
